import { getWorkspaceResourceIconType } from '@/shared/components/workspace-resources/WorkspaceResourceAvatar/configuration';

/**
 * Canonical Lifecycle glyph. Keep every Lifecycle surface on the same icon by
 * sourcing it from the workspace-resource registry.
 */
const LifecycleIcon = getWorkspaceResourceIconType('lifecycle');

export default LifecycleIcon;
